import { DestroyRef, ElementRef, Pipe, PipeTransform, QueryList, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';

@Pipe({
  name: 'pxwViewChildren',
  standalone: true,
})
export class ViewChildrenPipe implements PipeTransform {
  private destroyRef = inject(DestroyRef);

  elements$ = new BehaviorSubject<ElementRef<HTMLElement>[]>([]);
  elementsObservable$ = this.elements$.asObservable();

  transform(value?: QueryList<ElementRef<HTMLElement>>): Observable<ElementRef<HTMLElement>[]> {
    if (value) {
      setTimeout(() => {
        this.elements$.next(value.toArray());
      });

      value.changes.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        setTimeout(() => {
          this.elements$.next(value.toArray());
        });
      });
    }
    return this.elementsObservable$;
  }
}
